module.exports = __webpack_public_path__ + "static/media/fixRollerHardware.4f78bb71.png";